import React, {FC} from 'react'

import cn from 'classnames/bind'
import {AuthAction, withAuthUser} from 'next-firebase-auth'

import s from './LayoutAuth.module.scss'
import LayoutDefault from '../LayoutDefault'

const cx = cn.bind(s)

interface ILayoutAuthProps {
	className?: string
}

const LayoutAuth: FC<ILayoutAuthProps> = ({className, children}) => {
	return (
		<LayoutDefault hasMenuStub={false} className={cx('wrapper', className)}>
			{children}
		</LayoutDefault>
	)
}

LayoutAuth.displayName = 'LayoutAuth'

export default withAuthUser({
	whenAuthed: AuthAction.REDIRECT_TO_APP,
})(LayoutAuth)
